import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed190ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "author",
  href: "https://github.com/GravityTwoG",
  target: "_blank"
}, "GravityTwoG", -1))



export type Props = {
  class?: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    class: null
  },
  setup(__props: any) {

const props = __props as {
  class?: string;
}



const currentYear = new Date(Date.now()).getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(props.class)
  }, [
    _createTextVNode(" WebQR " + _toDisplayString(_unref(currentYear)) + ". Developed by ", 1),
    _hoisted_1
  ], 2))
}
}

})